import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
@Injectable()
export class ConfigService {
    public config: Object;
    public env: any;
    public result: Object;
    constructor(private http: HttpClient) {
    }

    public load() {
        var baseUrl = location.protocol + "//" + location.host;
        return new Promise((resolve, reject) => {

            //   .map(res => res.json())
            this.http.get(baseUrl + '/assets/config/env.json').pipe(map(res => res))
                .subscribe((envData) => {
                    this.env = envData;
                    //   .map(res => res.json())
                    this.http.get(baseUrl + '/assets/config/' + this.env.env + '.json?nocache=' + (new Date()).getTime()).pipe(map(res => res)).pipe(catchError((error: any) => {
                            return throwError(() => error.json().error || 'Server error during loading of config file');
                        })).subscribe((data) => {
                            this.config = data;
                            this.http.get(baseUrl + '/assets/config/uiConfiguration.json').pipe(map(res => res))
                                .subscribe((uiData) => {
                                    this.result = uiData;
                                    resolve(true);
                                });
                        });
                });
        });

    }

    getEnv(key: any) {
        if (this.env) {
            return this.env[key];
        } else {
            this.load().then(() => {
                return this.env[key];
            });
        }
    }
    get(key: any) {
        if (this.config) {
            return this.config[key];
        }
    }
    public getUiConfiguration(key: any) {
        if (this.result) {
            return this.result[key];
        }
    }
    public getCurrentYear(){
        return (new Date()).getFullYear();
    }
}